import {
  GET_DASHBOARD_LIST_REQUESTED,
  GET_DASHBOARD_LIST_SUCCEEDED,
} from "dashboard/actions/list";

const initialState = {
  isLoadingInitialList: true,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_DASHBOARD_LIST_REQUESTED:
      return { ...state, isLoadingInitialList: true };
    case GET_DASHBOARD_LIST_SUCCEEDED:
      return { ...state, isLoadingInitialList: false };
    default:
      return state;
  }
}
